import React, { useEffect, useState } from 'react';
import { Avatar, Form, Button, Spin, message } from 'antd';
import './versions.css';
import { useDispatch, useSelector } from 'react-redux';
import { saveDocumnetVersionData, setEditorSummary, setReadOnly } from '../../../app/EditorSlice';
import { useParams } from 'react-router-dom';
import { padServices } from '../../../api';
import { v4 } from 'uuid';

const VersionModalContent = ({ open, setOpen, setShowVersionButtons }) => {
    const dispatch = useDispatch();
    const lexicalEditor = useSelector((state) => state.editor.lexicalEditor);
    const editorSummary = useSelector((state) => state.editor.editorSummary);
    const userInformation = useSelector((state) => state.editor.userInformation);
    const [versions, setVersions] = useState([]);
    const [loading, setLoading] = useState(false);
    const { id } = useParams();

    useEffect(() => {
        const fetchVersions = async () => {
            if (open) {
                try {
                    const res = await padServices.getAllVersions(id);
                    setVersions(res?.data || []);
                } catch (e) {
                    console.error('Error fetching versions:', e);
                }
            }
        };
        fetchVersions();
    }, [open, id]);

    const handleVersionClick = (e, version) => {
        let oldData = '';
        if (lexicalEditor) {
            oldData = JSON.stringify(lexicalEditor.getEditorState());
        }

        dispatch(saveDocumnetVersionData({
            isVersionChange: true,
            updatedVersionData: version.versionData,
            originalData: {
                editorData: oldData,
                summary: editorSummary,
            }
        }));
        dispatch(setReadOnly(true));
        setShowVersionButtons(true);
        setOpen(false);
    };

    const handleCreateVersion = async () => {
        try {
            setLoading(true);
            let createdBy = {};
            if (userInformation) {
                createdBy = {
                    id: userInformation?.userId,
                    name: userInformation?.name,
                    image: userInformation?.image,
                };
            }
            const currentEditorStateJSON = JSON.stringify(lexicalEditor.getEditorState());
            let payload = {

                versionName: `testing-version-${v4()}`,
                createdBy: createdBy,
                versionData: {
                    summary: editorSummary,
                    milepadData: currentEditorStateJSON,
                },
                createdAt: new Date().toISOString(),
            }
            const res = await padServices.createVersion(id, payload);
            message.success(res?.data?.message);
            setVersions((prev) => [payload, ...prev]);
        } catch (e) {
            message.error('Error creating version');
            console.error('Error creating version:', e);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <div className="version-modal-header">
                <Button
                    type="primary"
                    className='version-button create-version-btn'
                    onClick={handleCreateVersion}
                    disabled={loading}
                >
                    {loading ? <Spin /> : 'Create Version'}
                </Button>
            </div>
            <div className='section-divider'></div>
            <Form className="version-container">
                {Array.isArray(versions) && versions.length > 0 ? (
                    versions
                        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)) // Sort by createdAt (most recent first)
                        .map((version, index) => {
                            if (version.createdBy) {
                                return (
                                    <Form.Item key={index}>
                                        <div
                                            className="versionData-box"
                                            onClick={(e) => handleVersionClick(e, version)}
                                        >
                                            <span className="version-createdAt">
                                                {new Date(version?.createdAt).toLocaleString()}
                                            </span>
                                            <div className="version-creator">
                                                {version?.createdBy?.image ? (
                                                    <Avatar
                                                        className="creator-avatar"
                                                        size="small"
                                                        src={version.createdBy.image}
                                                    />
                                                ) : (
                                                    <Avatar className="creator-avatar" size="small">
                                                        {version?.createdBy?.name?.charAt(0).toUpperCase()}
                                                    </Avatar>
                                                )}
                                                <span className="creator-name">{version?.createdBy?.name}</span>
                                            </div>
                                        </div>
                                    </Form.Item>
                                );
                            }
                            return null;
                        })
                ) : (
                    <div className="no-versions-message">
                        <p>No versions available. Create one to see it here!</p>
                    </div>
                )}
            </Form>

        </div>
    );
};

export default VersionModalContent;